import React from "react";

// Small monogram + wordmark used across all Chandan apps.
// Matches the top-left brand block on Chandan Registration Assistant.
export default function Brand({ eyebrow = "UNIFIED ECOSYSTEM" }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand">
      <div className="w-9 h-9 border border-foreground/90 flex items-center justify-center">
        <span className="font-serif text-[18px] leading-none text-foreground">C</span>
      </div>
      <div className="flex flex-col leading-tight">
        <span className="font-serif text-[20px] text-foreground tracking-tightest">
          Chandan
        </span>
        <span className="font-mono-meta text-muted-foreground">{eyebrow}</span>
      </div>
    </div>
  );
}
